import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { useTranslation } from 'react-i18next';
import { useUserStatus } from 'infrastructure/hooks/use-user-status';

import type { IBaseSelectBoxProps } from 'components/atoms/base-select-box/types';

const hiddenStatusNames = ['in chart', 'offline'];

const UserStatusSelectBox: React.FC<IBaseSelectBoxProps> = (props) => {
  const { t } = useTranslation();

  const { loading, statuses, currentStatus, setStatus } = useUserStatus();

  const inChartStatus = useMemo(() => {
    return statuses.find((el) => el.label.trim().toLowerCase() === 'in chart');
  }, [statuses]);
  const offlineStatus = useMemo(() => {
    return statuses.find((el) => el.label.trim().toLowerCase() === 'offline');
  }, [statuses]);

  const isInChartStatus = currentStatus === inChartStatus?.value;

  const filteredStatuses = useMemo(() => {
    if (isInChartStatus) return statuses;

    const s = statuses.filter(
      (el) => !hiddenStatusNames.includes(el.label.trim().toLowerCase()),
    );
    if (offlineStatus) {
      s.push({ ...offlineStatus, disabled: true });
    }
    return s;
  }, [statuses, isInChartStatus, offlineStatus]);

  return (
    <BaseSelectBox
      value={currentStatus}
      options={filteredStatuses}
      onChange={(_, rec) => setStatus(rec.record)}
      loading={loading}
      disabled={loading || isInChartStatus}
      placeholder={t('labels.yourStatus')}
      {...props}
    />
  );
};

export default UserStatusSelectBox;
